import type { FullOrderViewModel } from '@generated';
import { createContext, use, type ReactNode } from 'react';

export interface FullOrderContextModel {
	fullOrder: FullOrderViewModel;
	canEdit: boolean;
}

const FullOrderContext = createContext<FullOrderContextModel | null>(null);

export function FullOrderContextProvider({
	fullOrder,
	readOnly = false,
	children
}: {
	fullOrder: FullOrderViewModel;
	readOnly?: boolean;
	children: ReactNode;
}) {
	return <FullOrderContext value={{ fullOrder, canEdit: fullOrder.invariants.canBeEdited && !readOnly }}>{children}</FullOrderContext>;
}

export function useFullOrder() {
	const context = use(FullOrderContext);
	if (!context) {
		throw new Error('useFullOrder must be used within a FullOrderContextProvider');
	}
	return context;
}
